/**
 * Warning text that stays readable. warning.main (amber) on white is about 1.6:1, so light mode
 * uses the darkest warning shade (about 8:1) and dark mode the lightest on the dark paper.
 *
 * @param {object} theme
 * @returns {string}
 */
export function warningTextColor(theme) {
    return theme.palette.mode === "dark" ? theme.palette.warning.light : theme.palette.warning.darker
}
